import { render } from "./LicensesView.vue?vue&type=template&id=fd4ae8b8"
import script from "./LicensesView.vue?vue&type=script&lang=js"
export * from "./LicensesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__